import { IAnaliseLaboratorial } from "@/interfaces/IAnaliseLaboratorial";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface IRequisicaoAnaliseLaboratorialState {
  items: IAnaliseLaboratorial[];
}

const initialState: IRequisicaoAnaliseLaboratorialState = {
  items: [],
};

const requisicaoAnaliseLaboratorialSlice = createSlice({
  name: "REQUISICAO_ANALISE_LABORATORIAL",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<{ item: IAnaliseLaboratorial }>) => {
      const { item } = action.payload;
      state.items.push({ ...item, offlineId: Date.now() });
    },
    remove: (state, action: PayloadAction<{ offlineId: number }>) => {
      state.items = state.items.filter(
        (item) => item.offlineId !== action.payload.offlineId
      );
    },
    update: (state, action: PayloadAction<{ item: IAnaliseLaboratorial }>) => {
      const index = state.items.findIndex(
        (item) => item.offlineId === action.payload.item.offlineId
      );
      state.items[index] = action.payload.item;
    },
  },
});

export default requisicaoAnaliseLaboratorialSlice.reducer;

export const getRequisicoesAnaliseLaboratorial = (state: RootState) => {
  const listaInvertida = state.requisicaoAnaliseLaboratorial.items.map(
    (_, ind, lista) => {
      return lista[lista.length - ind - 1];
    }
  );

  return listaInvertida;
};
